import { ErrorTwoTone } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { DataGrid, DataGridProps, GridColDef, GridPaginationModel, GridRowsProp } from '@mui/x-data-grid';
import { FilterModel, TableToolbar } from './components/TableToolbar';

interface TableProps extends DataGridProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  pageSizeOptions: number[];
  loading: boolean;
  refetch: () => void;
  isFetching: boolean;
  paginationModel: GridPaginationModel;
  setPaginationModel: (paginationModel: GridPaginationModel) => void;
  totalRows: number;
  onRowClick?: (row: any) => void;
  error?: boolean;
  filters?: FilterModel[];
  toolbarExtra?: React.ReactNode;
}

export function Table({
  rows,
  columns,
  pageSizeOptions,
  loading,
  refetch,
  isFetching,
  paginationModel,
  setPaginationModel,
  totalRows,
  onRowClick,
  error,
  filters,
  toolbarExtra,
  ...rest
}: TableProps) {
  return (
    <DataGrid
      density='compact'
      components={{
        Toolbar: TableToolbar,
        NoRowsOverlay: () => (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            {error ? <ErrorTwoTone fontSize='large' color='error' /> : 'No rows'}
          </Stack>
        ),
      }}
      slotProps={{
        toolbar: { refetch: refetch, isFetching: isFetching, filters: filters, extra: toolbarExtra },
      }}
      rows={rows}
      columns={columns}
      pagination={true}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      paginationMode='server'
      pageSizeOptions={pageSizeOptions}
      checkboxSelection
      disableRowSelectionOnClick
      loading={loading || isFetching}
      rowCount={totalRows}
      showColumnVerticalBorder
      showCellVerticalBorder
      onRowClick={onRowClick}
      autoHeight
      {...rest}
    />
  );
}

export default Table;
